(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp.core', [
      'ngAnimate',
      'ngResource',
      'ui.router',
      'ngSanitize',
      'ui.bootstrap',
      'toaster',
      'pascalprecht.translate',
      'ng-sal',
      'ui.utils',
      'ui.mask',
      'ui.utils.masks',
      'services.config',
      'ngFileSaver',
      'angular-sparkline-charts',
      'angucomplete-alt',
      'chart.js',
      'blockUI',
      'angularMoment'
    ]);
})();
